import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'
import TextTruncate from 'react-text-truncate'

import Icon from 'Pods/Shared/Icon/Icon'
import ImageSorting from 'Pods/Shared/ImageSorting/ImageSorting'

import EmbedTriggersList from './EmbedTriggersList'

const Embed = ({
  id, url, imageProps, onRemove,
}) => {
  return (
    <Fragment>
      <div className="image-wrapper">
        <div className="delete-image is-hidden-when-sortable">
          <span onClick={(e) => onRemove(e, id)}>
            <Icon type={['far', 'times']} className="ml-5 is-bigger" />
          </span>
        </div>
        <img src={url} />
      </div>
      <div className="image-container__title is-hidden-when-sortable">
        <small>
          <div className="text-semibold text-capitalize">{imageProps.type}</div>
          <TextTruncate text={imageProps.title} truncateText="…" line={1} />
        </small>
      </div>
    </Fragment>
  )
}

const dropSpace = (
  <div className="col-12 col-sm-6 col-md-3 col-xl-2 u-mb10">
    <div className="image-container is-placeholder">
      <div className="image-wrapper">&nbsp;</div>
    </div>
  </div>
)

class EmbedsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      embeds: props.embeds,
      selectedEmbedsIds: [],
    }

    this.onSelectionChange = this.onSelectionChange.bind(this)
    this.onEmbedClick = this.onEmbedClick.bind(this)
    this.removeEmbed = this.removeEmbed.bind(this)
    this.onSortEnd = this.onSortEnd.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.embeds !== this.props.embeds) {
      this.setState({ embeds: this.props.embeds })
    }
  }

  onSelectionChange(selectedEmbedsIds) {
    this.setState({ selectedEmbedsIds })
  }

  onEmbedClick(id) {
    let selected = this.state.selectedEmbedsIds

    if (selected.includes(id)) {
      selected = selected.filter(selectedId => selectedId !== id)
    } else {
      selected.push(id)
    }

    this.setState({ selectedEmbedsIds: selected })
  }

  removeEmbed(e, id) {
    e.stopPropagation()

    this.props.deleteEmbed(id)
  }

  onSortEnd(newEmbedsOrder) {
    const sortedEmbeds = newEmbedsOrder.map((embedId) => {
      return this.state.embeds.find((embed) => embed.id === embedId)
    })

    this.setState({ embeds: sortedEmbeds })

    this.props.onChange(sortedEmbeds)
  }

  render() {
    return (
      <div className="sortable-images-list sortable-images-list--no-thumb is-not-spaced">
        <ImageSorting
          className="row"
          images={this.state.embeds.map((data) => {
            const isAutoGenerated = data.externalId?.startsWith('auto_generated_')
            const title = isAutoGenerated ? 'Auto-generated 3D viewer' : data.title

            return { id: data.id, url: data.image.gridUrl, type: data.type, title }
          })}
          imageComponent={Embed}
          extraItems={
            <EmbedTriggersList
              openModal={this.props.openModal}
              hasSupportedFileTypes={this.props.hasSupportedFileTypes}
              isGenerating={this.props.isGenerating}
              hasAutoGeneratedViewer={this.props.hasAutoGeneratedViewer}
            />
          }
          onDragStateChange={this.props.onDragStateChange}
          onChange={this.onSortEnd}
          onSelectionChange={this.onSelectionChange}
          onRemove={this.removeEmbed}
          spaceComponent={dropSpace}
          containerSizes="col-12 col-sm-6 col-md-3 col-xl-2"
        />
      </div>
    )
  }
}

EmbedsList.propTypes = {
  embeds: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.shape({ gridUrl: PropTypes.string.isRequired }),
    })
  ).isRequired,
  openModal: PropTypes.func.isRequired,
  deleteEmbed: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onDragStateChange: PropTypes.func.isRequired,
  hasSupportedFileTypes: PropTypes.bool,
  isGenerating: PropTypes.bool,
  hasAutoGeneratedViewer: PropTypes.bool,
}

export default EmbedsList
